import style from '../scss/head.module.scss';
import { Link, Logo, useBook, useFile, useTitle, useWindowSize } from 'topwrite';
import path from 'path';
import useConfig from '@@/use-config';
import { DocSearch } from '@topwrite/docsearch';
import { BsList } from '@react-icons/all-files/bs/BsList';
import { useSidebar } from '@/lib/use-sidebar';
import { useEffect } from 'react';

export default function Header() {

    const title = useTitle();
    const { summary } = useBook();
    const file = useFile();
    const config = useConfig();
    const navs = config.getValue('navs');

    const windowSize = useWindowSize();

    const { setOpen, open } = useSidebar();

    useEffect(() => {
        setOpen(false);
    }, [windowSize, file.path]);

    return <div className={style.head}>
        {windowSize == 'mobile' && <div onClick={() => setOpen(!open)} className={style.menu}>
            <BsList />
        </div>}
        <Link className={style.title} to='.'>
            <Logo />
            <span>{title}</span>
        </Link>
        <div className={style.navs}>
            {windowSize == 'desktop' && navs.map((nav, index) => {
                if (!nav.url.startsWith('http') && path.extname(nav.url) === '.md') {
                    const linkArticle = summary.getArticle(article => article.ref === nav.url);
                    if (linkArticle) {
                        return <Link key={index} to={linkArticle}>{nav.title}</Link>;
                    }
                }
                return <a key={index} href={nav.url} target='_blank'>{nav.title}</a>;
            })}
        </div>
        <div className={style.search}>
            <DocSearch />
        </div>
    </div>;
}
